import DOMPurify, { type Config } from "dompurify";

const SANITIZE_OPTIONS: Config = {
  FORBID_TAGS: ["script", "style", "iframe", "object", "embed", "form", "input", "button", "textarea", "select"],
  FORBID_ATTR: ["style"],
  ALLOW_DATA_ATTR: false,
  USE_PROFILES: {
    html: true,
  },
};

const DANGEROUS_URI_PATTERN = /^\s*(?:javascript|vbscript|data:\s*(?:text\/html|application\/javascript|image\/svg\+xml|text\/xml|application\/xhtml\+xml))/i;

export function sanitizeCampaignHtml(html: string): string {
  const sanitized = String(DOMPurify.sanitize(html, SANITIZE_OPTIONS));

  if (typeof DOMParser === "undefined") {
    return sanitized;
  }

  const parsed = new DOMParser().parseFromString(sanitized, "text/html");
  parsed.querySelectorAll("[href], [src]").forEach((element) => {
    for (const attributeName of ["href", "src"] as const) {
      const value = element.getAttribute(attributeName);
      if (value && DANGEROUS_URI_PATTERN.test(value)) {
        element.removeAttribute(attributeName);
      }
    }
  });

  return parsed.body.innerHTML;
}
